import React, { useEffect, useState } from "react";
// import ReactGA from "react-ga";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { useUserRoleSelector, useUserSelector } from "../../../store/selectors/user-selectors";
import { IRole } from "../../../store/types";
interface GAProviderProps {
  children: React.ReactNode;
}

export const GAProvider: React.FC<GAProviderProps> = ({ children }): JSX.Element => {
  const user = useUserSelector();
  const role: IRole | null = useUserRoleSelector();
  const location = useLocation();
  const [initialized, setInitialized] = useState<boolean>(true);

  useEffect(() => {
    ReactGA.initialize(
      import.meta.env.REACT_APP_GA4 as string
      // { debug: process.env.NODE_ENV !== 'production' }
    );
    setInitialized(true);
  }, []);

  useEffect(() => {
    if (user.id) {
      ReactGA.set({ userId: user.id });
    }
  }, [user.id]);

  useEffect(() => {
    if (role?.name) {
      ReactGA.set({ dimension1: role?.name });
    }
  }, [role?.name]);

  useEffect(() => {
    if (user.full_name) {
      ReactGA.set({ dimension2: user.full_name });
    }
  }, [user.full_name]);

  useEffect(() => {
    if (initialized) {
      ReactGA.send({ hitType: "pageview", path: location.pathname + location.search });
    }
  }, [initialized, location.pathname, location.search]);
  return <>{children}</>;
};
